import { buttonClasses } from "@mui/material/Button/index.js";
const createMuiButton = () => ({
  defaultProps: {
    disableRipple: true
  },
  styleOverrides: {
    root: {
      padding: `10px 20px`,
      borderRadius: 100,
      boxShadow: "unset",
      minWidth: "unset",
      "&:hover": {
        boxShadow: "unset"
      }
    }
  },
  variants: [
    {
      props: { size: "medium" },
      style: {
        padding: `10px 20px`
      }
    },
    {
      props: { size: "small" },
      style: {
        [`& .${buttonClasses.endIcon}`]: {
          fontSize: 16,
          marginLeft: 4,
          marginRight: -8,
          marginTop: -4,
          marginBottom: -4
        }
      }
    },
    {
      props: { variant: "text", color: "primary" },
      style: {
        padding: `10px 20px`,
        color: "#004734",
        "&:hover": {
          backgroundColor: "#caede7"
        },
        [`& .${buttonClasses.startIcon}`]: {
          color: "#004734"
        }
      }
    },
    {
      props: { variant: "outlined", color: "primary" },
      style: {
        color: "#00624F",
        borderColor: "#00624F",
        "&:hover": {
          backgroundColor: "#EDF8F7",
          borderColor: "#00624F",
          color: "#00624F"
        }
      }
    },
    {
      props: { variant: "contained", color: "primary" },
      style: {
        color: "#FBFEFD",
        backgroundColor: "#00624F",
        "&:hover": {
          backgroundColor: "#004734"
        }
      }
    }
  ]
});
export {
  createMuiButton as default
};
